import React from 'react';
import ReactDOM from 'react-dom';
import {ChainId, Config, DAppProvider} from '@usedapp/core';
import Routes from './routes';

const config: Config = {
    readOnlyChainId: ChainId.Mainnet,
};

ReactDOM.render(
    <React.StrictMode>
        <DAppProvider config={config}>
            <Routes/>
        </DAppProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
